module.exports = __webpack_public_path__ + "img/32.6f1069b.png";